import axios from "axios";
import format from "date-fns/format";
import isValid from "date-fns/isValid";
import { Utils } from "services/utils";

const CDN_URL = process.env.REACT_APP_CDN_URL;
const ChattanoogaIcon = `${CDN_URL}support/Chattanooga-icon-building.svg`;
const AtlantaIcon = `${CDN_URL}support/Atlanta-icon-building.svg`;
const HuntsvilleIcon = `${CDN_URL}support/Huntsville-icon-building.svg`;
const BirminghamIcon = `${CDN_URL}support/Birmingham-icon-building.svg`;
const ChattanoogaBuilding = `${CDN_URL}profile/images-chattanooga-building.svg`;
const AtlantaBuilding = `${CDN_URL}profile/images-atlanta-building.svg`;
const HuntsvilleBuilding = `${CDN_URL}profile/huntsville-building-modal.svg`;
const BirminghamBuilding = `${CDN_URL}profile/BIRMINGHAMBuilding.svg`;
const CloseIcon = `${CDN_URL}common/X-close-primary.svg`;

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/support`;
//const BASE_URL = "http://localhost:8085";

const config = {
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
};

const EMAIL_SERVICE_URL = "https://test.mydcblox.com/support-emailer/";

export class TicketApi {
  static remoteHandsEmailRequest = (params) => {
    return axios.post(EMAIL_SERVICE_URL, params, config);
  };

  static createTicket(params) {
    const url = `${BASE_URL}/ticket/create`;

    return axios.post(url, params, config);
  }

  static addNewPortalUser = (params) => {
    const url = `${BASE_URL}/ticket/create/user`;

    return axios.post(url, params, config);
  };

  static getTicketType(ticketType) {
    const url = `${BASE_URL}/ticket/type/${ticketType}`;

    return axios.get(url, config);
  }

  static getTicketComments(jiraIssue) {
    const url = `${BASE_URL}/ticket/comments/${jiraIssue}`;

    return axios.get(url, config);
  }

  static getTicketAttachments(jiraIssue) {
    const url = `${BASE_URL}/ticket/attachments/${jiraIssue}`;

    return axios.get(url, config);
  }

  static addNewRosterUser = (params) => {
    const url = `${BASE_URL}/ticket/create/roster`;

    return axios.post(url, params, config);
  };

  static sendSlackMessage(params) {
    const url = `${BASE_URL}/ticket/slack`;

    return axios.post(url, params, config);
  }

  static updateTicket(params) {
    const url = `${BASE_URL}/ticket/`;

    return axios.put(url, params, config);
  }

  static testUpdateTicket() {
    return new Promise((resolve) => {
      setTimeout(() => {
        const data = {
          status: 200,
          data: {
            error: null,
          },
        };
        resolve(data);
      }, 2000);
    });
  }

  static getIcon = (params) => {
    if (params.data.location === "Atlanta") {
      return AtlantaIcon;
    } else if (params.data.location === "Chattanooga") {
      return ChattanoogaIcon;
    } else if (params.data.location === "Birmingham") {
      return BirminghamIcon;
    } else {
      return HuntsvilleIcon;
    }
  };

  static getSmallBuildingIcons = (location) => {
    if (location === "Atlanta") {
      return AtlantaBuilding;
    } else if (location === "Chattanooga") {
      return ChattanoogaBuilding;
    } else if (location === "Huntsville") {
      return HuntsvilleBuilding;
    } else if (location === "Birmingham") {
      return BirminghamBuilding;
    } else if (location === "No Access") {
      return CloseIcon;
    } else {
      return ChattanoogaBuilding;
    }
  };

  static getTicket(caseId) {
    if (!caseId) return null;

    const url = `${BASE_URL}/ticket/${caseId}`;

    return axios.get(url, config);
  }

  static async getAll(page, type, status, viewAll, orgId) {
    const url = `${BASE_URL}/ticket/`;
    const params = {
      page,
      organizationId: orgId,
      types: [type.toLowerCase()],
      statuses: [status.toLowerCase()],
      viewAll,
    };
    const response = await axios.post(url, params, config);
    if (Utils.isValidResponse(response)) {
      const { tickets } = response.data;
      return { tickets, errors: null };
    }

    const { error } = response.data;
    return { tickets: null, error };
  }

  static getTicketCount(type, orgId) {
    const url = `${BASE_URL}/ticket/${orgId}/count/${type}`;

    return axios.get(url, config);
  }

  static async getRecentTickets(amount, orgId) {
    const url = `${BASE_URL}/ticket/${orgId}/recent/${amount}`;
    return axios.get(url, config);
  }

  // static async getAllOrg() {
  // 	const url = `${BASE_URL}/ticket/`;
  // 	const params = {
  // 		page,
  // 		types: [type.toLowerCase()],
  // 		statuses: [status.toLowerCase()],
  // 		viewAll: null,
  // 	};
  // 	const response = await axios.get(url,params, config);
  // 	if (Utils.isValidResponse(response)) {
  // 		const { tickets } = response.data;
  // 		return { tickets, errors: null };
  // 	}

  // 	const { error } = response.data;
  // 	return { tickets: null, error };
  // }

  // static getAll() {
  // 	const url = `${BASE_URL}/ticket/`;

  // 	return axios.get(url, config);
  // }

  static constructTicket(finalizedTicket, auth_status) {
    const {
      user: { firstname, lastname },
    } = auth_status;
    let ticket = null;

    if (!finalizedTicket) {
      ticket = {
        id: "10003",
        title: "Ticket Title",
        status: "Open",
        requestor: "Brandon",
        priority: "NORMAL",
        type: "SUPPORT",
        description: "This is the ticket description",
        dateSubmitted: "Oct 4, 2018 | 11:00 AM",
      };
    } else {
      ticket = {
        id: finalizedTicket.caseId || "",
        title: finalizedTicket.title,
        status: "Open",
        username: `${firstname} ${lastname}`,
        priority: finalizedTicket.priority,
        type: finalizedTicket.type,
        description: finalizedTicket.description,
        startDate: finalizedTicket.startDate,
      };
    }

    return ticket;
  }

  static extractComments(data) {
    if (!data || !data.ticketDetails || !data.ticketDetails.notes) {
      return [];
    }

    const { ticketDetails } = data;
    const { notes } = ticketDetails;

    return notes.map((note) => {
      const regex = /^x*?-x*?-?x*?$/;
      let time;
      let comment;
      let attachments;

      if (note.includes("File Added")) {
        if (note.match(regex)) {
          time = note.match(regex)[1];
          time = time.split("-")[0];
          const anchor = note.split("File Added: ")[1];
          comment = anchor;
          attachments = 1;
        }
      } else {
        const splitNote = note.split("-");
        time = splitNote[0];
        comment = splitNote[2];
      }

      return {
        id: ticketDetails.context.caseid,
        user: ticketDetails.supportRequest.requester,
        time,
        comment,
        attachments,
      };
    });
  }

  static formatDate(date) {
    const formattedDate = new Date(date);

    return `
            ${
              formattedDate.getMonth() + 1
            }/${formattedDate.getDate()}/${formattedDate.getFullYear()}
        `;
  }

  static formatDateOnTicket(date) {
    const formattedDate = new Date(date);

    return `
            ${
              formattedDate.getMonth() + 1
            }.${formattedDate.getDate()}.${formattedDate.getFullYear()}
    
        `;
  }

  static getFormattedDateString(date) {
    const formattedDate = new Date(date);

    if (isValid(formattedDate)) {
      return format(formattedDate, "MM-dd-yyyy HH:mm");
    } else {
      return " -- ";
    }
  }

  static getFormattedMonthDayYear(date) {
    const newDate = format(new Date(date), "MMMM do yyyy");

    return newDate;
  }

  static getFormattedMonth(date) {
    let formattedDate = new Date(date);

    try {
      if (date.substr(-1)) {
        //formattedDate = moment(`${date}Z`);
        formattedDate = new Date(date);
      }
    } catch (error) {
      console.log(error);
    }
    if (isValid(formattedDate)) {
      return format(formattedDate, "MM-dd-yyyy HH:mm");
    } else {
      return " -- ";
    }
  }
}
